import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../interceptors/PublicInterceptor";


// OBTIENER LISTADO DE BANCOS
export const getCountriesList = async(Token) => {
    const result = await PublicInterceptor('Global/Countries/token', 'GET', {}, Token)
    return result;
}

export const getCountryList = async(Token) => {
    const result = await PrivateInterceptor('Global/Countries', 'GET')
    return result;
}